import { Component, Input } from '@angular/core';

import * as moment from 'moment';

import { CostCenter } from 'src/shared/models/cost-center.model';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { WorkflowConstants } from 'src/app/workflow/workflow-constants.util';
import { WorkflowPage } from 'src/shared/models/workflow-page.model';
import { WorkflowPageUtil } from 'src/app/workflow/base-classes/workflow-page/workflow-page.util';
import { WorkflowUtilityService } from 'src/shared/services/workflow-utility.service';

@Component({
    selector: 'smt-staffing-plan-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: [ './page-header.component.scss' ]
})
export class PageHeaderComponent {
    @Input() currentPage: WorkflowPage;

    previousDay: string;

    constructor(private _shiftBlockService: ShiftBlockService, private _workflowUtility: WorkflowUtilityService) { 
        
    }

    async ngOnChanges() {
        this.previousDay = '';
        this.previousDay = await this.formatShiftBlockTime();
    }

    async formatShiftBlockTime(): Promise<string> {
        let shiftRecord = this.getShiftRecord();

        if (!shiftRecord || (this.currentPage.usePreviousDayInHeader && !shiftRecord.prevShiftRecord)) {
            return null;
        }
        
        if (this.currentPage.usePreviousDayInHeader) {            
            if (this.currentPage.shiftRecord) {
                // Find the last working day.  It is the most recent day prior to the current shiftRecord
                // workflowTimeFacility that was not closed.
                let previousUosDay =  await this._shiftBlockService.findPreviousUosWorkingDay(
                                                                this.currentPage.shiftRecord.costCenterId, 
                                                                this.currentPage.shiftRecord.workflowTimeFacility);
                if (!previousUosDay) {
                    return;
                }
                return moment(previousUosDay).format(WorkflowConstants.MomentFormat);
            }  
            else {
                return moment(shiftRecord.workflowTimeFacility).add(-1, 'day').format(WorkflowConstants.MomentFormat);
            }                      
        }

        return this._workflowUtility.formatShiftTime(shiftRecord.shiftBlock, shiftRecord.workflowTimeFacility);
    }

    getShiftRecord(): ShiftRecord {
        if (!this.currentPage || !this.currentPage.shiftRecord || !this.currentPage.shiftRecord.shiftBlock) {
            return null;
        } 

        let shiftRecord = this.currentPage.shiftRecord;        

        if (this.currentPage.usePreviousShiftRecordInHeader) {
            shiftRecord = this.currentPage.shiftRecord.prevShiftRecord;
        }

        return shiftRecord;
    }

    // Determine if a cost center is configured to be total uos and enter by day rather than enter by block.
    private isTotalUosByDay(costCenter: CostCenter): boolean {
        return costCenter && WorkflowPageUtil.hasUosConfiguration(costCenter) && !costCenter.ancillaryConfiguration.enterUOSByBlock;
    }

    showEditedName(): boolean { 
        let shiftRecord = this.getShiftRecord();
        if (this.currentPage.usePreviousDayInHeader && !shiftRecord.prevShiftRecord) {
            return false;
        }

        return shiftRecord && !!shiftRecord.user;
    }
}
